/* eslint-disable max-len */
/* eslint-disable no-unused-vars */
/* eslint-disable prefer-destructuring */
/* eslint-disable react/forbid-prop-types */
/* eslint-disable no-underscore-dangle */
import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import userServices from '../../../../redux/services/userServices';
import { Loading } from '../../../../helpers/utils';
import StudentsList from './StudentsList';
import StudentsInGroupList from './StudentsInGroupList';
import groupActions from '../../../../redux/actions/groupActions';

const AddStudents = ({
  groupId, group, subgroupStudents, subGroups, subGroupId, addStudentToGroup, removeStudentToGroup, allStudents,
}) => {
  const [groupStudents, setGroupStudents] = useState([]);
  const [accurateStudents, setAccurateStudents] = useState([]);
  const [loaded, setloaded] = useState(false);

  const loadData = async () => {
    setloaded(false);
    const res = allStudents;
    const studentsInSemesterArr = [];
    res?.tests.forEach((student) => {
      if (student.semester === group.semester) {
        studentsInSemesterArr.push(student);
      }
    });
    const studIds = [];
    const studentsWithoutSubgroup = [];
    subGroups.forEach((subgroup) => {
      subgroup.listIdUsers.forEach((user) => {
        studIds.push(user._id);
      });
    });
    studentsInSemesterArr.forEach((student) => {
      if (!studIds.includes(student._id)) {
        studentsWithoutSubgroup.push(student);
      }
    });
    setGroupStudents(studentsWithoutSubgroup);
    setloaded(true);
  };

  const addStudentToGroupReload = (subgroupid, studentIds) => {
    setloaded(false);
    addStudentToGroup(subgroupid, studentIds);
    loadData();
    setloaded(true);
  };

  const removeStudentToGroupReload = (subgroupid, studentIds) => {
    setloaded(false);
    removeStudentToGroup(subgroupid, studentIds);
    loadData();
    setloaded(true);
  };

  useEffect(() => {
    loadData();
    const tmp = [];
    subgroupStudents.forEach((user) => {
      if (user.semester === group.semester) {
        tmp.push(user);
      }
    });
    setAccurateStudents(tmp);
  }, []);

  return (
    <div>
      {loaded === false
        ? <Loading />
        : (
          <div
            style={{
              display: 'flex',
              marginTop: 25,
              flexDirection: 'row',
              alignItems: 'stretch',
              gap: '15px',
              justifyContent: 'center',
            }}
          >
            <StudentsList group={group} groupId={groupId} students={groupStudents} subGroupId={subGroupId} loadData={loadData} addStudentToGroup={addStudentToGroupReload} />
            <StudentsInGroupList group={group} groupId={groupId} students={accurateStudents} subGroupId={subGroupId} loadData={loadData} removeStudentToGroup={removeStudentToGroupReload} />
          </div>
        )}
    </div>
  );
};

AddStudents.propTypes = {
  groupId: PropTypes.string.isRequired,
  group: PropTypes.object.isRequired,
  subGroups: PropTypes.array.isRequired,
  allStudents: PropTypes.array.isRequired,
  subgroupStudents: PropTypes.array.isRequired,
  subGroupId: PropTypes.string.isRequired,
  addStudentToGroup: PropTypes.func.isRequired,
  removeStudentToGroup: PropTypes.func.isRequired,
};

function mapState(state) {
  const groupId = state.group.selectedGroup._id;
  const { company } = state.company;
  return { groupId, company };
}

const actionCreators = {
  getAll: groupActions.getAll,
};
const connectedAddStudents = connect(mapState, actionCreators)(AddStudents);

export default withRouter(connectedAddStudents);
